export const colors = {
  red: { argb: '00FF0000' },
  darkGreen: { argb: '004B7632' },
  lightGreen: { argb: '00BADBA5' },
  darkGray: { argb: '00949494' },
  lightGray: { argb: '00D3D3D3' },
  white: { argb: '00FFFFFF' },
  darkBlue: { argb: '004775B2' },
};

export const solidFill = (color: { argb: string }) => ({
  type: 'pattern',
  pattern: 'solid',
  fgColor: color,
} as const);
